import { render, staticRenderFns } from "./associationList.vue?vue&type=template&id=cc6f7c3c&scoped=true"
import script from "./associationList.vue?vue&type=script&lang=js"
export * from "./associationList.vue?vue&type=script&lang=js"
import style0 from "./associationList.vue?vue&type=style&index=0&id=cc6f7c3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6f7c3c",
  null
  
)

export default component.exports